import * as React from 'react';
import { assign as _assign} from 'lodash';
import { connect } from 'react-redux';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';

export interface UsersDispatcherProps {
  dispatch: any;
  users: GlobalPrivateState['users'];
}

const dispatchKey = 'users';

class UsersDispatcherContainer extends React.Component<UsersDispatcherProps, any> {

  componentDidMount() {
    this.dispatchUsers();
  }

  // componentDidUpdate(prevState: UsersDispatcherProps) {
  //   const prevSearch = prevState.queryState.search;
  //   const search = this.props.queryState.search;
  //   if (
  //     ((prevSearch && prevSearch.indexOf('sword') > -1) || (search && search.indexOf('sword') > -1)) && 
  //     prevSearch !== search
  //   ) {
  //     this.dispatchUsers();
  //   }
  // }

  public render() {
    return null;
  }

  // private get search(): string | undefined {
  //   const { queryState } = this.props;
  //   return queryState.params.sword;
  // }

  private dispatchUsers() {
    // TODO - Allow passing additional object of query params
    // const queryParams = {
    //   // order: 'email DESC',
    //   // limit: 5... will need to do something like this for searching more users later
    // };
    const queryParams: any = {
      order: 'email'
    }

    // if (this.search) {
    //   queryParams.sword = this.search;
    // }

    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      dispatchKey, {
        url: `/Users/admin-list`,
        queryParams
      },
      true
    ));
  }
}

export const UsersDispatcher = connect((state: GlobalPrivateState) => ({
  users: state.users
}))(UsersDispatcherContainer);
